export const apiUrl = process.env.REACT_APP_API_URL;
export const apiUrlNodeWs = process.env.REACT_APP_NODE_WS_URL;
export const apiUrlNode = process.env.REACT_APP_NODE_URL;

export const isZohoPeopleUpdateDisabled =
  process.env.REACT_APP_ZOHO_POEOPLE_UPDATE_DISABLED?.toLocaleLowerCase() === 'true';
